/* Unsolved password page: ASCII grid with logo mosaic + cursor reveal.
   Words, brand word and seed come from data attributes set in the theme editor. */
(function () {
  function rng(seed) {
    var a = seed;
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function build(root) {
    var bgEl = root.querySelector('[data-us-bg]');
    var hoverEl = root.querySelector('[data-us-hover]');
    var logoEl = root.querySelector('[data-us-logo]');
    if (!bgEl || !hoverEl || !logoEl) return;
    var brand = (root.dataset.brand || 'UNSOLVED').trim();
    var words = (root.dataset.words || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    var showLogo = root.dataset.mosaic !== 'false';
    var COLS = 220, ROWS = 80;
    var sym = '!@#$?/)+(&%*=~[]{}<>^\\|;:';
    var r = rng(parseInt(root.dataset.seed, 10) || 419);
    function pick() { return sym[Math.floor(r() * sym.length)]; }
    var bg = [], y, i;
    for (y = 0; y < ROWS; y++) {
      var line = '';
      while (line.length < COLS) {
        var x = r();
        if (x < 0.12 && brand) line += brand;
        else if (x < 0.24 && words.length) line += words[Math.floor(r() * words.length)];
        else { var n = 2 + Math.floor(r() * 9); for (i = 0; i < n; i++) line += pick(); }
        line += ' ';
      }
      bg.push(line.slice(0, COLS).split(''));
    }
    var mask = '00000000000004000000000,0000000000000c000000000,0000000000001c000000000,0000000000007c000000000,00000000000078000000000,00000000000038000000000,0000000000007c000000000,000000000000fe000000000,000000000000ff000000000,000000000000fb800000000,00000000000079e00000000,00000000000070f00000000,000000000000f0380000000,000000000000e1fc0000000,000000000000efff0000000,000380000000ffe78000000,0000e0000003ff83e000000,00007000001ffc01f000000,0000380000fff000f800000,00000e000fdfc0000000000,00000f807e7fc0000000000,00007380fbffe0000000000,0001e0e1f7efe0000000000,0007807fff07c0000000000,001f003ff007c00001f8000,007c001fc007800000f8000,01f001ffc0078004007c000,07c00ffbf0078006003e000,3f007ffff80f8007001f000,fe03f87ffc0f80fb000fc00,fc1fc01fff9f81ff0007f00,ff1f0003ffffc7ff000ff00,3fff00007fffffffe21ff80,07ff00000fffffffffffff0,007fffffffffffffffffff0,0007fffffffffffffffffe0,0000fffffffffffffffffe0,0007fffffffffffffffcfe0,0003ffffffffffff3f80fe0,0000fff0f0ffffffcf80fe0,00001c03c07ffffff3e0fe0,0000007f003ffffffff1ff0,00000078003ffefffffffe0,000001e0003ffc3fff7ffc0,00000f80003fe03ffc3ffe0,00007f00003f007ff0ff9f0,0000fe00003f007fe3fffe0,0000fff0007f807ffff0f80,00007fffe1ff80ffff80fe0,000001ffffff80ffff01cf8,00000003ffff81fff80783c,000000000ff7c1ffc00f00e,0000000001efc1ff001e007,00000000000f81ff007c003,000000000002003f80f8001,000000000000000fc3e0000,0000000000000007ffc0000,0000000000000001ff80000,0000000000000000ff00000,00000000000000003e00000'.split(',');
    var LW = 92, LH = mask.length;
    var ox = Math.floor((COLS - LW) / 2), oy = Math.floor((ROWS - LH) / 2);
    var logo = [];
    for (y = 0; y < ROWS; y++) { var row = []; for (i = 0; i < COLS; i++) row.push(' '); logo.push(row); }
    if (showLogo) {
      mask.forEach(function (hex, ly) {
        var bits = '';
        for (var k = 0; k < hex.length; k++) bits += ('0000' + parseInt(hex[k], 16).toString(2)).slice(-4);
        for (var lx = 0; lx < LW; lx++) {
          if (bits[lx] === '1') {
            var ch = bg[oy + ly][ox + lx];
            logo[oy + ly][ox + lx] = ch === ' ' ? pick() : ch;
            bg[oy + ly][ox + lx] = ' ';
          }
        }
      });
    }
    var bgText = bg.map(function (l) { return l.join(''); }).join('\n');
    bgEl.textContent = bgText;
    hoverEl.textContent = bgText;
    logoEl.textContent = logo.map(function (l) { return l.join(''); }).join('\n');

    var raf = 0, cx = 0, cy = 0, lastTouch = 0;
    var small = window.matchMedia && window.matchMedia('(max-width: 600px)').matches;
    var size = Math.round((parseInt(root.dataset.reveal, 10) || 170) * (small ? 0.6 : 1));
    function reveal(x, y) {
      cx = x; cy = y;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var rect = bgEl.getBoundingClientRect();
        var m = 'radial-gradient(' + size + 'px circle at ' + Math.round(cx - rect.left) + 'px ' + Math.round(cy - rect.top) + 'px, #000 0%, rgba(0,0,0,.4) 50%, transparent 100%)';
        hoverEl.style.webkitMaskImage = m;
        hoverEl.style.maskImage = m;
        hoverEl.style.opacity = '1';
      });
    }
    root.addEventListener('mousemove', function (e) { reveal(e.clientX, e.clientY); });
    root.addEventListener('mouseleave', function () { hoverEl.style.opacity = '0'; });
    function onTouch(e) { var t = e.touches && e.touches[0]; if (!t) return; lastTouch = Date.now(); reveal(t.clientX, t.clientY); }
    root.addEventListener('touchstart', onTouch, { passive: true });
    root.addEventListener('touchmove', onTouch, { passive: true });

    var touchOnly = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (touchOnly && !reduced && root.dataset.drift !== 'false') {
      var t0 = performance.now();
      (function loop(now) {
        if (Date.now() - lastTouch > 2500) {
          var rr = root.getBoundingClientRect(), t = (now - t0) / 1000;
          reveal(rr.left + rr.width * (0.5 + 0.35 * Math.sin(t * 0.45)), rr.top + rr.height * (0.5 + 0.3 * Math.sin(t * 0.31 + 1)));
        }
        requestAnimationFrame(loop);
      })(t0);
    }
  }
  function init() { document.querySelectorAll('[data-us-root]').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
